import { useTheme } from 'styled-components';
import { useCrmObjectType } from 'framework-listing-lib/internal/providers/CrmObjectTypeListingClientProvider';
function useSearchInputProps() {
  const {
    searchInputProps
  } = useCrmObjectType();
  return searchInputProps;
}
export function useHasSearchInput() {
  const searchInputProps = useSearchInputProps();
  return Boolean(searchInputProps.hasSearchInput);
}
export function useLegacySearchInput() {
  const searchInputProps = useSearchInputProps();
  return Boolean(searchInputProps.legacySearchInput);
}
export function useOnQueryChange() {
  const searchInputProps = useSearchInputProps();
  return searchInputProps.onQueryChange;
}
export function useSearchInputPlaceholder() {
  const searchInputProps = useSearchInputProps();
  return searchInputProps.placeholder;
}
export function useSearchInputWidth() {
  const searchInputProps = useSearchInputProps();
  const theme = useTheme();
  if (typeof searchInputProps.width === 'string' && theme.space[searchInputProps.width]) {
    return theme.space[searchInputProps.width];
  }
  if (typeof searchInputProps.width === 'number') {
    return `${searchInputProps.width}px`;
  }
  return searchInputProps.width;
}
export function useIsSearchInputDisabled() {
  const searchInputProps = useSearchInputProps();
  return Boolean(searchInputProps.disabled);
}